import { Dispatch, useState } from 'react';

const useUploadProgress = (): [
  number, Dispatch<number>, (progress: any) => void,
] => {
  const [progress, setProgress] = useState(0);

  const progressCallback = (p: any) => {
    if (p.loaded) {
      setProgress(Math.floor((p.loaded / p.total) * 100));
    }
  };

  return [progress, setProgress, progressCallback];
};

export default useUploadProgress;
